module.exports = __webpack_public_path__ + "AbankSans-Bold-7c8d92648871bb468f4360222b338bdc.woff";